import {
  Outlet,
  useLoaderData,
  useParams,
  useRouteLoaderData,
} from 'react-router-dom';
import { styled } from 'styled-components';
import TopBar from 'components/TopBar';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;

/**
 * root route that houses all the UI chrome for Dashboards
 */
export default function Dashboards() {
  const { user, portfolios } = useRouteLoaderData('root');
  const { projects } = useLoaderData();
  const { dashboardId, orgKey } = useParams();

  const active = projects?.reduce((acc, project) => {
    const current = project.dashboards.find(({ id }) => id === dashboardId);
    if (current) {
      return { project, id: current.id, name: current.name };
    }
    return acc;
  }, null);

  const sortedProjects = active
    ? [
        active.project,
        ...projects.filter(({ key }) => active.project.key !== key),
      ]
    : projects;

  const organization = portfolios?.reduce((acc, portfolio) => {
    const current = portfolio.organizations.find(({ key }) => key === orgKey);
    if (current) {
      return { ...current, portfolio: portfolio.name };
    }
    return acc;
  }, {});

  return (
    <Wrapper>
      <TopBar
        projects={sortedProjects}
        active={active}
        orgKey={orgKey}
        portfolios={portfolios}
        organization={organization}
      />

      {user && <Outlet />}
    </Wrapper>
  );
}
